export default __webpack_public_path__ + "static/media/icon-weather-conditions.c4f5c755.svg";